import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';

export interface BuildInfo {
  buildNumber: string;
  buildDate: string;
}

@Injectable({
  providedIn: 'root'
})
export class BuildInfoService {
  constructor(private http: HttpClient) {}

  getBuildInfo(): Observable<BuildInfo> {
    return this.http.get<BuildInfo>('/assets/build-info.json').pipe(
      catchError(() => {
        return of({ buildNumber: '0.0.0.0', buildDate: new Date().toISOString() });
      })
    );
  }
}
